/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_signin_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to send a message`)
};

const es_contact_signin_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesión para enviar un mensaje`)
};

const de_contact_signin_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melde dich an, um eine Nachricht zu senden`)
};

const nl_contact_signin_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld je aan om een bericht te sturen`)
};

const fr_contact_signin_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connectez-vous pour envoyer un message`)
};

const it_contact_signin_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi per inviare un messaggio`)
};

const pt_br2_contact_signin_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entre para enviar uma mensagem`)
};

const pt_contact_signin_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sessão para enviar uma mensagem`)
};

const ja_contact_signin_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージを送るにはサインインしてください`)
};

const zh_contact_signin_heading = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后即可发送消息`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_signin_heading = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_signin_heading(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_signin_heading", locale)
	if (locale === "en") return en_contact_signin_heading(inputs)
	if (locale === "es") return es_contact_signin_heading(inputs)
	if (locale === "de") return de_contact_signin_heading(inputs)
	if (locale === "nl") return nl_contact_signin_heading(inputs)
	if (locale === "fr") return fr_contact_signin_heading(inputs)
	if (locale === "it") return it_contact_signin_heading(inputs)
	if (locale === "pt-BR") return pt_br2_contact_signin_heading(inputs)
	if (locale === "pt") return pt_contact_signin_heading(inputs)
	if (locale === "ja") return ja_contact_signin_heading(inputs)
	return zh_contact_signin_heading(inputs)
};